// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"8c472c47","508":"090303ae","776":"0912e0bf"}[chunkId] + ".chunk.js";
};